// @flow

import type { TimesheetProjection } from '../../common//typings';

export default function getBreakMinutes(lastTimesheetProjection: TimesheetProjection): number {
  let minutes = lastTimesheetProjection.breakMinutes;

  if (lastTimesheetProjection.onBreak) {
    minutes += (new Date().getTime() - lastTimesheetProjection.lastActionLocal) / 1000 / 60;
  }

  return Math.floor(minutes);
}
